import LessonHistoryList from './LessonHistoryList';

export default LessonHistoryList;
